import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { VStack } from 'tio-reimagined/components/layout';
import Heading from 'tio-reimagined/components/heading';
import ContributionTimeline from 'tio-employee/components/reimagined/contribution-timeline';
import type { ContributionHistoryData } from 'tio-employee/services/reimagined-data';

interface SlrPaymentHistorySignature {
  Args: {
    model: ContributionHistoryData | undefined;
  };
}

export default class SlrPaymentHistoryRouteComponent extends Component<SlrPaymentHistorySignature> {
  get payments() {
    return this.args.model?.payments ?? [];
  }

  <template>
    {{! template-lint-disable no-bare-strings }}
    <VStack class="w-full min-w-0 gap-4">
      <div class="flex items-center justify-between">
        <Heading @level={{1}} class="app-page-title">Payment History</Heading>
        <LinkTo
          @route="authenticated.slr.dashboard"
          class="text-sm font-medium text-teal-600 hover:text-teal-700"
        >
          Back to dashboard
        </LinkTo>
      </div>

      <ContributionTimeline @payments={{this.payments}} />
    </VStack>
  </template>
}
